export const START_ZOOM = 1;
export const MAX_ZOOM = 15;
export const PART_DIAGRAM_IMAGE_WIDTH = 283;
export const PART_DIAGRAM_IMAGE_HEIGHT = 138;
